export default __webpack_public_path__ + "static/media/aQI.33728da0.png";